import { goNextGalaxy } from '@/galaxy-cruise/utils'
import { store } from '@/store'
import { canvasDafeDatUrl } from '@/utils/canvas'
import { download } from '@/utils/file'
import { EquatorialCoord } from '@hscmap/angle'
import { Component, Vue } from "vue-property-decorator"
import { detect } from 'detect-browser'

@Component
export default class extends Vue {
  async goNextQuestion() {
    goNextGalaxy()
  }

  get gc() {
    return store.galaxyCruise
  }

  get quest() {
    return this.gc.quest
  }

  takePhoto() {
    const browser = detect()
    if (browser === null || browser.name === 'edge' || browser.name === 'ie') {
      alert(`お使いのブラウザでは本機能はご使用できません`)
      return
    }
    const globe = store.currentGlobe()
    const url = canvasDafeDatUrl(globe.canvas.domElement, 'image/png', ({ canvas, ctx }) => {
      const { a: aRad, d: dRad } = store.currentFrame.view
      const coord = EquatorialCoord.fromRad(aRad, dRad)
      const { a, d } = coord.toString()
      const fontSize = 18
      ctx.font = `${fontSize}px sans-serif`
      ctx.fillStyle = 'rgba(0, 255, 0, 0.5)'
      ctx.fillText(`\u03B1=${a} \u03B4=${d}`, 0.5 * fontSize, canvas.height - 0.5 * fontSize)
    })
    download(filename(), url)
  }

  image(file: string) {
    return `./images/main-buttons/${file}.png`
  }

  get tooltipDelay() {
    return 0
  }

  get tooltipOffset() {
    return 20
  }
}


function filename() {
  const v = store.currentFrame.view
  const e = EquatorialCoord.fromRad(v.a, v.d)
  const { a, d } = e.toString()
  return `galaxycruise_${a}_${d}.png`.replace(/:/g, '_')
}